<template lang="pug">
.check-input-ok-cancel-modal
  b-modal(v-model="_value" size="lg" :title="title" no-close-on-backdrop no-close-on-esc @ok="ok" @cancel="cancel")
    .check-input-ok-cancel-modal-body
      .confirm
        .error-message 文書が登録されていない宛先があります。
        .message.mb-2 {{ message }}
        ul.confirm-list(v-for="item in listItems")
          li {{ item }}
        label
          input(type="checkbox" @click="checked = !checked")
          span 確認しました

    div(slot="modal-footer" slot-scope="{ ok, cancel }")
      button.btn.modal-ok-btn(v-if="checked" type="button" @click="ok()") OK
      button.btn.modal-ok-btn.disable(v-else type="button" disabled) OK
      button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### チェックボックス付きOK／キャンセルモーダル
 */
@Component
export default class CheckInputOkCancelModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;

  /** タイトル */
  @Prop()
  title!: string;
  /** メッセージ */
  @Prop()
  message!: string;
  /** 箇条書きするリスト */
  @Prop()
  listItems!: string[];

  /** 確認しました */
  checked: boolean = false;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  /**
   * OKボタン押下イベント
   */
  public ok(): void {
    this.$emit("ok");
    this.checked = false;
    return;
  }

  /**
   * キャンセルボタン押下イベント
   */
  public cancel(): void {
    this.$emit("cancel");
    this.checked = false;
    return;
  }
}

export interface TargetFacility {
  /** 施設ID */
  id: number;
  /** 施設名 */
  name: string;
  /** 利用者ID */
  residentId: number;
  /** 選択したか否か */
  checked: boolean;
}
</script>
